import React, { useState } from "react";
import { toast } from "react-toastify";
import LandingShell from "../components/Layout/LandingShell";
import ConfigDB from "../config";
import useSeo from "../utils/useSeo";

const SECTIONS = [
  { id: "companies", title: "Empresas", icon: "🏢" },
  { id: "products", title: "Produtos", icon: "📦" },
  { id: "sales", title: "Vendas", icon: "💳" },
  { id: "reserves", title: "Reservas", icon: "🏷️" },
  { id: "refunds", title: "Reembolsos", icon: "↩️" },
];

const ENDPOINTS = {
  companies: [
    {
      method: "POST",
      path: "ecommerce-all-company-list",
      title: "Listar empresas com e-commerce ativo",
      noAuth: true,
      desc:
        "Endpoint público (sem autenticação). Devolve as empresas que têm o e-commerce ativo. Usado como entry-point para descobrir empresas disponíveis na plataforma.",
      response: `{
  "status": 200,
  "data": [
    {
      "id": 74,
      "name": "Lisbon Tech Solutions",
      "address": "Avenida da Liberdade 150, Lisbon, Portugal",
      "zipcode": "1250-146",
      "company_registration_number": "LTS-202403",
      "reg_number_dismantler": "LTS-DISM-001",
      "phone_number": "+351-21-345-6789",
      "country": "Portugal",
      "email": "demo@gmail.com"
    }
  ]
}`,
    },
  ],

  products: [
    {
      method: "GET",
      path: "ecommerce-get-product-inventory",
      title: "Listar produtos em inventário",
      desc:
        "Obtém produtos com stock disponível para venda. Suporta paginação, pesquisa e ordenação. Cada produto inclui dados da viatura de origem, referências, imagens, vídeos e danos.",
      query: [
        { key: "tokens", desc: "Token da empresa (gerado na área reservada)" },
        { key: "limit", desc: "Resultados por página (default 50)" },
        { key: "page", desc: "Página atual (default 1)" },
        { key: "search", desc: "Pesquisa livre (nome, referência, matrícula)" },
        { key: "order_field", desc: "Campo de ordenação (created_at, price_1, updated_at)" },
        { key: "order_type", desc: "asc | desc" },
        { key: "language", desc: "pt | en | es | fr | de | it" },
      ],
      response: `{
  "status": 200,
  "total": 38592,
  "data": [
    {
      "id": 309,
      "company_id": "2",
      "vehicle_id": "96",
      "part_code": "ACB-4821-X",
      "quantity": 3,
      "price_1": 250.0,
      "price_2": 230.0,
      "part_description": "Front Left Headlight Assembly",
      "is_custom_size": 1,
      "parts_weight": 4.5,
      "parts_length": 60,
      "parts_width": 25,
      "parts_height": 20,
      "vat_included": 1,
      "cc": "1998",
      "cv": "150",
      "kw": "110",
      "parts_internal_id": "FH-789654",
      "reg_number_dismantler": "REG-2025-789",
      "state_id": "1",
      "condition_id": "1",
      "product_name": "Front Left Headlight",
      "vehicle_model_name": "Ford Focus 2022",
      "vehicle_make_name": "Ford",
      "vehicle_variant_name": "2.0 EcoBoost ST (206 kW / 280 hp)",
      "brand_name": "Bosch",
      "motor_code": "4G63T",
      "inventory_status": "In Stock",
      "created_at": "2025-03-06T06:25:41.000Z",
      "updated_at": "2025-03-05T09:08:24.136Z",
      "vehicle_year": "2022",
      "bar_code_parts": "1234567890123",
      "is_master_part": "0",
      "master_part_id": "17",
      "master_part_inventory_id": "0",
      "state_name": "New",
      "condition_name": "OEM",
      "token": "9xxffqomimqgph7h8odq5v54ehuw1atjvf",
      "vehicle": {
        "vin_number": "1FA6P8TH9K5123456",
        "registration": "AB-123-CD",
        "registration_plate": "82-83-HM",
        "vehicle_brand": "Ford",
        "vehicle_model": "Focus ST",
        "vehicle_year": "2022",
        "vehicle_kms": "12000",
        "vehicle_doors": "2",
        "vehicle_fuel": "Petrol",
        "vehicle_motorization": "2.0 EcoBoost",
        "vehicle_model_id": "22",
        "make_id": "4",
        "variants_id": "105946",
        "vehicle_uuid": "58725682-b564-4a01-86a2-ed75626b8809",
        "vehicle_type_name": "Car",
        "fuel_type_name": "Petrol",
        "variants_name": "2.0 EcoBoost ST (206 kW / 280 hp)",
        "motor_code": "4G63T",
        "vehicle_category": "Hatchback",
        "vehicle_color": "Blue",
        "vehicle_cyllinder": "4",
        "vehicle_tare": "1400",
        "vehicle_approval": "Yes",
        "vehicle_total_gross_weight": "1800",
        "vehicle_parts": "52",
        "status": 1,
        "vehicle_process_end_date": "2025-03-27T18:30:00.000Z",
        "is_vehicle_depollution": 0,
        "created_by": "2",
        "updated_by": "2",
        "vehicle_internal_id": "12",
        "state_parking": "1",
        "vehicle_image": [
          { "vehicle_image": "https://example.com/uploads/vehicle/images/focus1.jpg", "sort_order": "1" },
          { "vehicle_image": "https://example.com/uploads/vehicle/images/focus2.jpg", "sort_order": "2" }
        ]
      },
      "part_qty_list": [
        {
          "parts_id": "309",
          "uuid": "c970a0c2-8fbf-4a68-9d2a-3a35fdeafe85",
          "id": 264,
          "qty": 1,
          "location_ids": "",
          "part_rating": 5,
          "location_name": "Shelf A1"
        }
      ],
      "parts_reference": [
        {
          "id": 16,
          "parts_id": "309",
          "is_main": 0,
          "condition_id": "1",
          "type_id": "1",
          "reference_code": "OEM-12345",
          "type_name": "Compatible",
          "condition_name": "OEM"
        },
        {
          "id": 17,
          "parts_id": "309",
          "is_main": 1,
          "condition_id": "2",
          "type_id": "2",
          "reference_code": "AF-67890",
          "type_name": "Written on the label",
          "condition_name": "Aftermarket"
        }
      ],
      "part_damage": [
        {
          "damage_description": "Minor scratch on housing",
          "location_damage": "Internal",
          "type_damage": "Not affect function",
          "damage_rating": 1.5
        }
      ],
      "image_list": [
        {
          "image_url": "https://tpsoftware.s3.eu-west-1.amazonaws.com/uploads/vehicle/parts/1742277347163-12.jpg",
          "part_name": "Distribuidor",
          "image_uuid": "adae8407-cb7f-4614-b270-2d5b2b6683fc",
          "part_id": "309",
          "uuid": "a83884fc-86f8-4fab-a041-3be250b14eab",
          "part_code": "pvfmnjhmog",
          "quantity": 1,
          "part_price": 0,
          "inventory_status": 1,
          "part_description": "",
          "id": 202,
          "damage_list": [
            {
              "id": 34,
              "video_url": null,
              "damage_description": "Minor scratch",
              "vehicle_part_id": "574",
              "img_video_id": "202",
              "damage_id": "39"
            }
          ]
        }
      ],
      "video_list": [
        {
          "image_url": "https://tpsoftware.s3.eu-west-1.amazonaws.com/uploads/vehicle/parts/thumb_1742277359082.jpg",
          "video_url": "https://tpsoftware.s3.eu-west-1.amazonaws.com/uploads/vehicle/parts/1742277357393-sd.mp4",
          "part_name": "Distribuidor",
          "image_uuid": "d6717bcd-684a-4549-95a7-45484c55db64",
          "part_id": "309",
          "uuid": "a83884fc-86f8-4fab-a041-3be250b14eab",
          "part_code": "pvfmnjhmog",
          "quantity": 1,
          "part_price": 0,
          "inventory_status": 1,
          "part_description": "",
          "id": 49,
          "damage_list": []
        }
      ]
    }
  ]
}`,
    },
    {
      method: "GET",
      path: "ecommerce-check-product-inventory",
      title: "Verificar disponibilidade",
      desc:
        "Valida se um produto tem stock suficiente antes de criar uma encomenda. Use sempre antes de `generate-sales-order` ou `generate-reserve-order`.",
      query: [
        { key: "company_id", desc: "ID da empresa" },
        { key: "product_id", desc: "ID do produto (id da vehicle_parts)" },
        { key: "qty", desc: "Quantidade pretendida" },
      ],
      response: `// Disponível
{
  "message": "Product quantity available",
  "status": 200
}

// Indisponível
{
  "message": "Product quantity not available!",
  "status": 404
}`,
    },
  ],

  sales: [
    {
      method: "GET",
      path: "ecommerce-generate-sales-order",
      title: "Criar ordem de venda",
      desc:
        "Gera uma nova encomenda de venda. Recebe body com dados de cliente, provider (em caso de marketplace), produtos, impostos, portes e políticas de reembolso. O stock é automaticamente reservado.",
      body: `{
  "tokens": "9xxffqomimqgph7h8odq5v54ehuw1atjvf",
  "sync_id": 0,
  "num_products": 2,
  "total_value_products": 320.00,
  "total_value_shipping": 15.00,
  "total_value_packaging": 4.50,
  "total_value_other_parcel": 2.00,
  "tax_vat_products": 48.00,
  "tax_vat_shipping": 2.25,
  "tax_vat_packaging": 0.68,
  "tax_vat_other_parcel": 0.30,
  "exemption_vat_products": 0,
  "exemption_vat_shipping": 0,
  "exemption_vat_packaging": 0,
  "exemption_vat_other_parcel": 0,
  "maximum_sale_alert_date": "2025-03-15",
  "notes_sale": "Fragile items. Deliver between 9 AM - 12 PM.",
  "seller_takes_care_shipping": 1,
  "provider_takes_care_shipping": 0,
  "seller_invoice_provider": 0,
  "seller_invoice_client": 1,
  "shipping_label": "https://example.com/documents/shipping_label_12345.pdf",
  "client": [
    {
      "name": "Michael Johnson",
      "country_code": "US",
      "shipping_address": "789 Sunset Blvd",
      "postal_code": "90028",
      "city": "Los Angeles",
      "invoice_address": "123 Business Lane",
      "vat_number": "US987654321",
      "country_code_vat_number": "US",
      "phone": "+13235551234",
      "email": "michael.johnson@example.com",
      "whatsapp": "+13235551234"
    }
  ],
  "provider": [
    {
      "name": "Elite Auto Parts Ltd.",
      "country_code": "DE",
      "shipping_address": "42 Autobahnstrasse",
      "postal_code": "60314",
      "city": "Frankfurt",
      "invoice_address": "10 Industrial Park",
      "vat_number": "DE876543210",
      "country_code_vat_number": "DE",
      "phone": "+492215554321",
      "email": "sales@eliteautoparts.de",
      "whatsapp": "+492215554321"
    }
  ],
  "products": [
    {
      "product_id": 380,
      "product_name": "Front Brake Pads - Bosch",
      "part_qty_id": 1056,
      "price_without_vat": 95.00,
      "tax_vat": 14.25,
      "exemption_vat": 0,
      "images": [1, 2]
    },
    {
      "product_id": 395,
      "product_name": "Air Filter - Mann Filter",
      "part_qty_id": 1057,
      "price_without_vat": 130.00,
      "tax_vat": 19.50,
      "exemption_vat": 0,
      "images": [1, 2]
    }
  ]
}`,
      response: `{
  "status": 200,
  "message": "Sales order created successfully",
  "order_id": 1024,
  "uuid": "9dd973a7-2a18-47d1-bd36-00df54b5cc32"
}`,
    },
    {
      method: "GET",
      path: "ecommerce-get-sales",
      title: "Listar vendas",
      desc:
        "Obtém as encomendas de venda da empresa autenticada, com filtros de paginação, pesquisa, ordenação e estado.",
      query: [
        { key: "tokens", desc: "Token da empresa" },
        { key: "limit", desc: "Resultados por página (default 50)" },
        { key: "page", desc: "Página actual (default 1)" },
        { key: "search", desc: "Pesquisa livre" },
        { key: "order_field", desc: "created_at, updated_at, id" },
        { key: "order_type", desc: "asc | desc" },
        { key: "language", desc: "pt | en | es | fr | de | it" },
        { key: "status", desc: "0=pending · 1=accepted · 2=shipped · 3=delivered" },
      ],
      response: `{
  "status": 200,
  "total": 128,
  "data": [
    {
      "id": 1024,
      "ecommerce_id": "ORD-20250311-001",
      "order_status": 2,
      "num_products": 2,
      "total_value_products": "499.99",
      "total_value_shipping": "15.00",
      "total_value_packaging": "3.50",
      "total_value_other_parcel": "0.00",
      "tax_vat_products": "39.99",
      "tax_vat_shipping": "1.50",
      "tax_vat_packaging": "0.25",
      "tax_vat_other_parcel": "0.00",
      "exemption_vat_products": false,
      "exemption_vat_shipping": false,
      "exemption_vat_packaging": false,
      "exemption_vat_other_parcel": false,
      "maximum_sale_alert_date": "2025-03-15T00:00:00.000Z",
      "notes_sale": "Customer requested express shipping.",
      "seller_takes_care_shipping": true,
      "provider_takes_care_shipping": false,
      "seller_invoice_provider": false,
      "seller_invoice_client": true,
      "shipping_label": "https://example.com/shipping/ORD-20250311-001.pdf",
      "shipping_company": "FedEx",
      "shipping_tracking_code": "FDX123456789",
      "reason_failed_sale": null,
      "created_at": "2025-03-11T10:45:32.714Z",
      "updated_at": "2025-03-11T12:01:10.512Z",
      "invoice_number": "INV-20250311-001",
      "order_status_name": "Shipped",
      "product_list": [
        {
          "id": 341,
          "product_id": 7654,
          "quantity": 1,
          "price_without_vat": 299.99,
          "tax_vat": 23.99,
          "exemption_vat": false,
          "product_name": "Gaming Laptop - 15.6 inch",
          "image_list": [
            "https://example.com/products/laptop1.jpg",
            "https://example.com/products/laptop2.jpg"
          ]
        }
      ],
      "client_list": [
        {
          "name": "Michael Johnson",
          "shipping_address": "45 Greenview Ave",
          "country_code": "US",
          "postal_code": "90210",
          "city": "Los Angeles",
          "vat_number": "US987654321",
          "country_code_vat_number": "US",
          "phone": "+13235551234",
          "email": "michael.johnson@example.com",
          "whatsapp": "+13235551234"
        }
      ],
      "provider_list": [
        {
          "name": "Tech Distributors Inc.",
          "shipping_address": "500 Tech Park, Suite 42",
          "country_code": "US",
          "postal_code": "30303",
          "city": "Atlanta",
          "vat_number": "US223344556",
          "country_code_vat_number": "US",
          "phone": "+14045557890",
          "email": "support@techdistributors.com",
          "whatsapp": "+14045557890"
        }
      ],
      "bill_list": [
        {
          "proposal_seller_refund_value": null,
          "refund_reason": null,
          "proposal_provider_refund_value": null,
          "proposal_seller_type_refund": null,
          "proposal_provider_type_refund": null,
          "refund_state_provider": null,
          "refund_accept_full": false,
          "refund_accept_partial": false,
          "refund_accept_value": null,
          "arrived_to_warehouse": null,
          "billing_document": "https://example.com/invoices/INV-20250311-001.pdf",
          "id_billing_document": 1024,
          "billing_credit_note": null,
          "id_billing_credit_note": null,
          "billing_other_document": null,
          "id_other_document": null,
          "type_other_document": null,
          "refund_status_name": ""
        }
      ]
    }
  ]
}`,
    },
  ],

  reserves: [
    {
      method: "GET",
      path: "ecommerce-generate-reserve-order",
      title: "Criar reserva",
      desc:
        "Cria uma reserva temporária de produtos para um cliente. Pode incluir data de fim, alertas e múltiplos endereços de envio.",
      body: `{
  "tokens": "9xxffqomimqgph7h8odq5v54ehuw1atjvf",
  "reservation_name": "Reserva Cliente Premium",
  "reservation_end_date": "2025-05-20 17:00",
  "reservation_notes": "Cliente confirma até dia 18",
  "send_email": 1,
  "send_whatsapp": 0,
  "reservation_end_alert": "2025-05-19 09:00",
  "client": {
    "name": "Michael Johnson",
    "country_code": 1,
    "district": 1,
    "city": 1,
    "bill_address": "789 Sunset Blvd",
    "postal_code": "90028",
    "shipping_address": ["123 Business Lane"],
    "vat_number": "US987654321",
    "vat_country_code": "US",
    "vat_percentage": 23,
    "is_vat_exempt": 0,
    "phone_number": "+13235551234",
    "email": "michael.johnson@example.com",
    "whatsapp_number": "+13235551234"
  },
  "products": [
    {
      "product_id": 380,
      "qty": 1,
      "price": 95.00
    }
  ]
}`,
      response: `{
  "status": 200,
  "message": "Reserve created successfully",
  "uuid": "9dd973a7-2a18-47d1-bd36-00df54b5cc32"
}`,
    },
    {
      method: "GET",
      path: "ecommerce-reserve-order-list",
      title: "Listar reservas",
      desc: "Obtém a lista de reservas da empresa com paginação e ordenação.",
      query: [
        { key: "tokens", desc: "Token da empresa" },
        { key: "limit", desc: "default 10" },
        { key: "page", desc: "default 1" },
        { key: "order_field", desc: "id | created_at | reservation_end_date" },
        { key: "order_type", desc: "asc | desc" },
      ],
      response: `{
  "status": 200,
  "data": [
    {
      "id": 16,
      "uuid": "9dd973a7-2a18-47d1-bd36-00df54b5cc32",
      "company_id": "2",
      "client_id": "7",
      "reservation_end_date": null,
      "warehouses_id": null,
      "users_id": null,
      "shipping_price": "0.00",
      "packing_price": "0.00",
      "parcel_price": "0.00",
      "reservation_notes": null,
      "send_email": 0,
      "send_whatsapp": 0,
      "reservation_status": 1,
      "created_at": "2025-05-12T11:38:11.000Z",
      "updated_at": "2025-05-12T11:38:11.384Z",
      "deleted_at": null,
      "created_by": "1",
      "updated_by": null,
      "deleted_by": null,
      "reservation_name": "My Reserve",
      "task_id": null,
      "reservation_end_alert": null,
      "client_name": "Michael Johnson",
      "status_name": "Active",
      "token": "9xxffqomimqgph7h8odq5v54ehuw1atjvf",
      "part_list": [
        {
          "id": 160,
          "uuid": "cb128000-deaf-4890-985a-7d1b5eee617e",
          "company_id": "2",
          "reservation_id": "16",
          "parts_id": "380",
          "reserve_price": "95.00",
          "reserve_vat_price": "0.00",
          "location_id": null,
          "reservation_order_notes": null,
          "created_at": "2025-05-12T11:38:11.384Z",
          "updated_at": "2025-05-12T11:38:11.384Z",
          "deleted_at": null,
          "created_by": "1",
          "updated_by": "1",
          "deleted_by": null,
          "part_qty_label_id": "381",
          "part_code": "vx8gdtojig",
          "part_name": "Brake Pad - Front",
          "namePartPT": "Pastilha de Freio - Dianteira",
          "warehouse_name": null
        }
      ]
    }
  ]
}`,
    },
    {
      method: "GET",
      path: "ecommerce-reserve-order-details",
      title: "Detalhes de reserva",
      desc:
        "Devolve os detalhes completos de uma reserva, incluindo totais calculados (qty, price, vat).",
      query: [
        { key: "tokens", desc: "Token da empresa" },
        { key: "uuid", desc: "UUID da reserva" },
      ],
      response: `{
  "message": "success",
  "status": 200,
  "data": {
    "id": 16,
    "uuid": "9dd973a7-2a18-47d1-bd36-00df54b5cc32",
    "company_id": "2",
    "client_id": "7",
    "reservation_end_date": null,
    "warehouses_id": null,
    "users_id": null,
    "shipping_price": "0.00",
    "packing_price": "0.00",
    "parcel_price": "0.00",
    "reservation_notes": null,
    "send_email": 0,
    "send_whatsapp": 0,
    "reservation_status": 1,
    "created_at": "2025-05-12T11:38:11.000Z",
    "updated_at": "2025-05-12T11:38:11.384Z",
    "deleted_at": null,
    "created_by": "1",
    "updated_by": null,
    "deleted_by": null,
    "reservation_name": "My Reserve",
    "task_id": null,
    "reservation_end_alert": null,
    "client_name": "Michael Johnson",
    "status_name": "Active",
    "token": "9xxffqomimqgph7h8odq5v54ehuw1atjvf",
    "part_list": [
      {
        "id": 160,
        "uuid": "cb128000-deaf-4890-985a-7d1b5eee617e",
        "company_id": "2",
        "reservation_id": "16",
        "parts_id": "380",
        "reserve_price": "95.00",
        "reserve_vat_price": "0.00",
        "location_id": null,
        "reservation_order_notes": null,
        "part_qty_label_id": "381",
        "part_code": "vx8gdtojig",
        "part_name": "Brake Pad - Front",
        "namePartPT": "Pastilha de Freio - Dianteira",
        "warehouse_name": null
      }
    ],
    "total_qty": 1,
    "total_price": 95,
    "total_vat_price": 0
  }
}`,
    },
  ],

  refunds: [
    {
      method: "POST",
      path: "refund-notification",
      title: "Notificar reembolso",
      desc:
        "Registe um pedido de reembolso para uma venda existente. Pode ser total (FULL) ou parcial (PARTIAL). O valor e motivo são registados e notificados à empresa.",
      query: [
        { key: "token", desc: "Token da empresa" },
        { key: "id_sale", desc: "ID da venda (retornado em `generate-sales-order`)" },
        { key: "type_refund", desc: "FULL | PARTIAL" },
        { key: "refund_request_value", desc: "Valor em EUR (ex: 499.99)" },
        { key: "reason_refund", desc: "Motivo do reembolso (texto livre)" },
      ],
      response: `// Sucesso
{
  "message": "Refund successfully created.",
  "status": 200
}

// Token inválido / empresa não permite reembolsos
{
  "message": "Invalid token request or company does not allow refund",
  "status": 404
}`,
    },
  ],
};

const METHOD_COLORS = {
  GET: "#10b981",
  POST: "#f59e0b",
  PUT: "#3b82f6",
  DELETE: "#ef4444",
  PATCH: "#8B5CF6",
};

const ApiDocsPublic = () => {
  useSeo({
    title: "Documentação da API",
    description:
      "Documentação completa da API REST TP Software. Endpoints para produtos, inventário, vendas, reservas e reembolsos. Autenticação por token, exemplos e payloads.",
    keywords: "API TP Software, API REST, documentação API, integração, webhooks, endpoints, marketplaces auto",
    path: "/api-docs",
  });

  const [active, setActive] = useState("companies");
  const [copied, setCopied] = useState("");
  const rawBase = ConfigDB?.data?.api_url || "https://api.tp.software/api/v1/";
  const baseUrl = rawBase.replace(/\/+$/, ""); // strip trailing slash(es)

  const copy = (txt, key) => {
    navigator.clipboard.writeText(txt);
    setCopied(key);
    toast.success("Copiado!");
    setTimeout(() => setCopied(""), 1500);
  };

  const section = SECTIONS.find((s) => s.id === active);
  const endpoints = ENDPOINTS[active] || [];

  return (
    <LandingShell title="Documentação API">
      <div className="tp-docs">
        <aside className="tp-docs-sidebar">
          <div className="tp-docs-sidebar-label">CATEGORIAS</div>
          {SECTIONS.map((s) => (
            <button
              key={s.id}
              onClick={() => setActive(s.id)}
              className={`tp-docs-nav-item${active === s.id ? " active" : ""}`}
            >
              <span className="tp-docs-nav-icon">{s.icon}</span>
              <span className="tp-docs-nav-title">{s.title}</span>
              <span className="tp-docs-nav-count">
                {(ENDPOINTS[s.id] || []).length}
              </span>
            </button>
          ))}

          <div className="tp-docs-base-url">
            <div className="tp-docs-base-url-label">Base URL</div>
            <code
              className="tp-docs-base-url-val"
              onClick={() => copy(baseUrl, "base")}
              title="Clique para copiar"
            >
              {baseUrl.replace(/https?:\/\//, "")}
              {copied === "base" && <span style={{ marginLeft: 6 }}>✓</span>}
            </code>
          </div>

          <div className="tp-docs-auth-note">
            <div className="tp-docs-auth-note-title">🔑 Autenticação</div>
            <p>
              O token é gerado na área reservada de cada vendedor (Settings →
              E-commerce Hash). Passe-o como query param <code>tokens</code> ou
              <code> token</code> nas chamadas que o exigem.
            </p>
          </div>
        </aside>

        <main className="tp-docs-main">
          <div className="tp-docs-section-header">
            <div className="tp-docs-section-icon">{section?.icon}</div>
            <div>
              <h2>{section?.title}</h2>
              <p>
                {endpoints.length} endpoint
                {endpoints.length !== 1 ? "s" : ""} disponíve
                {endpoints.length !== 1 ? "is" : "l"}
              </p>
            </div>
          </div>

          {endpoints.length === 0 && (
            <div className="tp-docs-empty">
              <div style={{ fontSize: 48 }}>🚧</div>
              <h3>Em breve</h3>
              <p>
                Esta secção está a ser documentada. Estará disponível antes do
                lançamento de Maio 2026.
              </p>
            </div>
          )}

          {endpoints.map((ep, i) => {
            const fullUrl = `${baseUrl}/${ep.path}`;
            return (
              <div key={i} className="tp-docs-endpoint">
                <div className="tp-docs-endpoint-head">
                  <span
                    className="tp-docs-method"
                    style={{
                      background: METHOD_COLORS[ep.method] + "20",
                      color: METHOD_COLORS[ep.method],
                      borderColor: METHOD_COLORS[ep.method] + "60",
                    }}
                  >
                    {ep.method}
                  </span>
                  <code
                    className="tp-docs-path"
                    onClick={() => copy(fullUrl, `path-${i}`)}
                    title="Clique para copiar URL completo"
                  >
                    /{ep.path}
                    {copied === `path-${i}` && (
                      <span className="tp-docs-copied"> ✓ copiado</span>
                    )}
                  </code>
                  {ep.noAuth ? (
                    <span className="tp-docs-auth-badge tp-docs-auth-public">
                      🔓 Sem autenticação
                    </span>
                  ) : (
                    <span className="tp-docs-auth-badge tp-docs-auth-private">
                      🔐 Token necessário
                    </span>
                  )}
                </div>

                <h3 className="tp-docs-ep-title">{ep.title}</h3>
                {ep.desc && <p className="tp-docs-ep-desc">{ep.desc}</p>}

                {ep.query && ep.query.length > 0 && (
                  <div className="tp-docs-block">
                    <div className="tp-docs-block-label">Query parameters</div>
                    <table className="tp-docs-table">
                      <tbody>
                        {ep.query.map((q) => (
                          <tr key={q.key}>
                            <td>
                              <code>{q.key}</code>
                            </td>
                            <td>{q.desc}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}

                {ep.body && (
                  <div className="tp-docs-block">
                    <div className="tp-docs-block-label-row">
                      <span className="tp-docs-block-label">Request body</span>
                      <button
                        className="tp-docs-copy-btn"
                        onClick={() => copy(ep.body, `body-${i}`)}
                      >
                        {copied === `body-${i}` ? "✓ copiado" : "Copiar"}
                      </button>
                    </div>
                    <pre className="tp-docs-code">{ep.body}</pre>
                  </div>
                )}

                {ep.response && (
                  <div className="tp-docs-block">
                    <div className="tp-docs-block-label-row">
                      <span className="tp-docs-block-label">Resposta</span>
                      <button
                        className="tp-docs-copy-btn"
                        onClick={() => copy(ep.response, `resp-${i}`)}
                      >
                        {copied === `resp-${i}` ? "✓ copiado" : "Copiar"}
                      </button>
                    </div>
                    <pre className="tp-docs-code tp-docs-code-success">
                      {ep.response}
                    </pre>
                  </div>
                )}
              </div>
            );
          })}

          <div className="tp-docs-cta">
            <h3>Precisa de ajuda?</h3>
            <p>
              Contacte-nos em{" "}
              <a href="mailto:geral@tp.software">geral@tp.software</a> ou pelo{" "}
              <a href="tel:+351253600550">+351 253 600 550</a>.
            </p>
          </div>
        </main>
      </div>
    </LandingShell>
  );
};

export default ApiDocsPublic;
